import { Badge } from '@/components/ui/Badge';
import { ROCK_STATUS_META } from '@/lib/eos/rockStatus';
import type { RockStatus } from '@/api/eos/rocks.api';

/** Colored status chip for a rock — On track / Off track / Done. */
export function RockStatusBadge({ status, className }: { status: RockStatus; className?: string }) {
  const meta = ROCK_STATUS_META[status];
  return (
    <Badge variant={meta.variant} className={className}>
      {meta.label}
    </Badge>
  );
}
